import { IntlProvider } from 'react-intl';
import useLocale from '../hooks/useLocale';
import { loadMessages } from '../i18n/index';

const TranslationProvider = ({
  children,
}: {
  children: React.ReactNode;
}): JSX.Element => {
  const { locale, defaultLocale } = useLocale();

  const messages = loadMessages(locale);

  return (
    <IntlProvider
      locale={locale}
      defaultLocale={defaultLocale}
      messages={messages}
    >
      {children}
    </IntlProvider>
  );
};

export default TranslationProvider;
